import React from 'react'
import { Helmet } from 'react-helmet'
import { injectIntl } from 'react-intl'
import RouteMap from 'assets/RouteMap'
import DefaultHelmet from './DefaultHelmet'
import CloudinaryURLHelper from 'assets/CloudinaryURLHelper'
import Sanitizer from 'assets/Sanitizer'
import { TAB_TRANSLATION_MAPPING } from 'components/ShowPageTabs/ShowPageTabsHelper'
import URLHandler from 'assets/URLHandler.js'

class SchoolShowHelmet extends React.Component {
    render () {
        const { school } = this.props

        const logoURL = CloudinaryURLHelper.getImageUrl('META_IMAGE', school.logo?.cloudinary_key)
        const schoolImageURL = CloudinaryURLHelper.getImageUrl('META_IMAGE', (school.card_image?.cloudinary_key || school.banner_image?.cloudinary_key))
        const title = school.name
        const description = school.description

        const knowsLanguageString = () => {
            let languageList = ''
            if (school.en) languageList += 'English, '
            if (school.fr) languageList += 'French, '
            if (school.nl) languageList += 'Dutch'
            languageList = languageList.trim().replace(/,\s*$/, '')

            return languageList
        }

        const sameAsUrlString = () => {
            let urlList = ''
            if (school.url) urlList += `"${school.url}", `
            if (school.url_tiktok) urlList += `"${school.url_tiktok}", `
            if (school.url_linkedin) urlList += `"${school.url_linkedin}", `
            if (school.url_instagram) urlList += `"${school.url_instagram}", `
            if (school.url_facebook) urlList += `"${school.url_facebook}", `
            urlList = urlList.trim().replace(/,\s*$/, '')

            return urlList
        }

        const subOrganizationUrlString = () => {
            let subOrganizationString = ''
            school.faculties.forEach((faculty) => {
                const facultyUrl = `${RouteMap.Show('education', school.url)}/${TAB_TRANSLATION_MAPPING.faculties[URLHandler.GetLocaleFromUrl()]}`
                const facultyImageURL = CloudinaryURLHelper.getImageUrl('META_IMAGE', faculty.image?.cloudinary_key)
                subOrganizationString += `{
                    "@type": "EducationalOrganization",
                    "name": "${Sanitizer.SanitizeForApplicationJson(faculty.title)}",
                    "description" : "${Sanitizer.SanitizeForApplicationJson(faculty.description)}",
                    "image" : "${facultyImageURL}",
                    "telephone" : "+1-877-672-7777",
                    "@id": "${facultyUrl}",    
                    "url": "${facultyUrl}",    
                    "address":{
                      "@type":"PostalAddress",
                      "addressLocality":"${faculty.address?.city}",
                      "postalCode":"${faculty.address?.zip}",
                      "addressCountry":"BE"
                    },  
                }`
            })
            subOrganizationString = subOrganizationString.trim().replace(/,\s*$/, '')
            subOrganizationString = `[${subOrganizationString}]`
            return subOrganizationString
        }

        return <>
            <DefaultHelmet
                title={title}
                description={description}
                imageCloudinaryKey={logoURL}
            />
            <Helmet>
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`https://www.student.be${window.location.pathname}`} />
                <meta property='og:updated_time' content={school.updated_at} />
                <link rel="canonical" href={RouteMap.Show('education', school.slug)} />
                {school.nl && <link rel="alternate" hrefLang="nl-BE" href={RouteMap.Show('education', school.slug, 'nl')} />}
                {school.nl && <link rel="alternate" hrefLang="x-default" href={RouteMap.Show('education', school.slug, 'nl')} />}
                {school.fr && <link rel="alternate" hrefLang="fr-BE" href={RouteMap.Show('education', school.slug, 'fr')} />}
                {school.fr && <link rel="alternate" hrefLang="x-default" href={RouteMap.Show('education', school.slug, 'fr')} />}
                {school.en && <link rel="alternate" hrefLang="en-BE" href={RouteMap.Show('education', school.slug, 'en')} />}
                {school.en && <link rel="alternate" hrefLang="x-default" href={RouteMap.Show('education', school.slug, 'en')} />}
                <script type="application/ld+json">
                    {`{
                        "@context": "http://schema.org",
                        "@type": "EducationalOrganization",
                        "name": "${Sanitizer.SanitizeForApplicationJson(school.name)}",
                        "description" : "${Sanitizer.SanitizeForApplicationJson(school.description)}",
                        "logo" : "${logoURL}",
                        "image" : "${schoolImageURL}",
                        "@id": "https://www.student.be${window.location.pathname}",
                        "url": "https://www.student.be${window.location.pathname}",
                        "knowsLanguage": "[${knowsLanguageString()}]"
                        "email" : "${school.email}",
                        "sameAs": ${sameAsUrlString()},
                        "subOrganization": "${subOrganizationUrlString()}",
                    }`}
                </script>
            </Helmet>

        </>
    }
}

export default injectIntl(SchoolShowHelmet)
